export function setPage(page) {
    return {
        type: 'SET_CURRENT_PAGE',
        payload: page
    };
}

